import { render, staticRenderFns } from "./divePlace.vue?vue&type=template&id=63bd0e87&scoped=true&"
import script from "./divePlace.vue?vue&type=script&lang=js&"
export * from "./divePlace.vue?vue&type=script&lang=js&"
import style0 from "./divePlace.vue?vue&type=style&index=0&id=63bd0e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd0e87",
  null
  
)

export default component.exports